export async function uploadToServer(file) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch("https://www.denisbitter.de/stage01/api/upload_model.php", {
    method: "POST",
    body: formData,
  });

  const result = await res.json();

  if (!result.success) {
    throw new Error(result.error || "Upload fehlgeschlagen");
  }

  return result.url;
}
